import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import affiliateApiClient, { setAffiliateSession } from '../lib/affiliateApiClient';

// Handles both the initial "welcome, set your password" invite link and a
// "forgot password" reset link — both issue the same one-time token.
export default function AffiliateSetPassword() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 10) return setError('Password must be at least 10 characters.');
    if (password !== confirm) return setError('Passwords do not match.');

    setSubmitting(true);
    try {
      const { data } = await affiliateApiClient.post('/set-password', { token, password });
      if (data.sessionToken) {
        setAffiliateSession(data.sessionToken);
        navigate('/affiliate/dashboard');
      } else {
        setError(data.message || 'Password set, but your account is not active yet.');
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Could not set your password.');
    } finally {
      setSubmitting(false);
    }
  };

  if (!token) {
    return <div className="min-h-screen flex items-center justify-center text-gray-600 px-4 text-center">This link is missing its token. Ask your SurFox AI contact to resend it.</div>;
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <form onSubmit={submit} className="max-w-md w-full bg-white rounded-2xl border border-gray-200 p-8 shadow-sm space-y-4">
        <h1 className="text-2xl font-bold text-gray-900 text-center">Set your password</h1>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">New password</label>
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm" />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Confirm password</label>
          <input type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm" />
        </div>
        {error && <p className="text-sm text-red-600">{error}</p>}
        <button disabled={submitting} className="w-full py-3 bg-indigo-600 text-white rounded-lg font-medium hover:bg-indigo-700 disabled:opacity-50">
          {submitting ? 'Saving...' : 'Set password and continue'}
        </button>
      </form>
    </div>
  );
}
